<template>
	<div class='main-mybody' id='weitijao'>
		<a-row>
			<a-col :span='6'><div>開戶狀態 </div>
			<a-select v-model="params.revisistatus" placeholder="請選擇" style='width:8rem' @change="getdate">
					<a-select-option v-for="(item) in admintypeArr" :key="item.key+'100'" :value="item.value"
						style='width:10rem'>{{item.text}}</a-select-option>
				</a-select>
			</a-col>
			<a-col :span='6'><div>開始時間 </div>
				<a-date-picker v-model='params.begindate' placeholder='請選擇開始時間' :disabled-date="disabledDate"
					style='width: 8rem;' />
			</a-col>
			<a-col :span='6'><div>結束時間 </div>
				<a-date-picker v-model='params.enddate' placeholder='請選擇結束時間' :disabled-date="disabledDates"
					style='width: 8rem;' />
				<!-- <a-range-picker :placeholder="['開始時間','結束時間']" format="DD/MM/YYYY"
				v-model="params.timeDate" @change='fanhand'> -->
				<!-- </a-range-picker> -->
			</a-col>
			<a-col :span='1'></a-col>
			<a-col :span='5'>
				<div class='wrplf' style="text-align: right;">
					<a-button class="topBtn" style="background-color:#3bc7a1;" @click="getdate">
						<img src="@/image/icon_sousuo.png" class="btnIcon" />
						<span>搜索</span>
					</a-button>
					<a-button class="topBtn" style="background-color:#ffa647;margin-left:auto;" @click="clearEvent">
						<img src="@/image/icon_chongzhi.png" class="btnIcon" />
						<span>重置</span>
					</a-button>
				</div>
			</a-col>
			<!-- <a-col :span='6'>回訪狀態
			<a-select v-model="params.revisistatus" placeholder="請選擇" style='width:8rem' @change="getdate">
					<a-select-option v-for="(item) in huiarr" :key="item.key+'200'" :value="item.value"
						style='width:10rem'>{{item.text}}</a-select-option>
				</a-select>
			</a-col> -->
			<a-col :span='24'>
				<div class='look_tuijian'>
					<div>
						<img src="@/image/ipone1.png" alt="">
						跟進中 {{params.revisitnum}}
					</div>
					<div>
						<img src="@/image/ipone2.png" alt="">
						未跟進 {{params.unrevisitnum}}
					</div>
					<div>
						<img src="@/image/no.png" alt="">
						無效用戶 {{params.invalidnum}}
					</div>
				</div>
				<div id='bottomMain'>
					<a-table id='ediotable' style="width:100%;" :columns="columns" :data-source="columnsData"
						:rowKey='(record, index) => index' :bordered="true" :pagination="false">
						<div slot='telphonenumber' slot-scope="record">
							<div class='fath_yiti'>
								<div v-if='record.revisistatus == 1'><img src="@/image/ipone1.png" alt="" class='wimg'>
								</div>
								<div v-if='record.revisistatus == 2'><img src="@/image/ipone2.png" alt="" class='wimg'>
								</div>
								<div v-if='record.revisistatus == 3'><img src="@/image/no.png" alt="" class='wimg'>
								</div>
								<div style="width: 80%;text-align: left;">{{record.telphonenumber}}</div>
							</div>
						</div>
						<div slot='name' slot-scope="record" style="margin-left: 12%;text-align: left;">{{record.name||'無記錄'}}</div>
						<div slot='step' slot-scope="record" style="text-align: left;">{{record.step}}</div>
						<div slot='area' slot-scope="record" style="margin-left: 12%;text-align: left;">{{record.area}}</div>
						<div slot='revisit_remark' slot-scope="record" style="text-overflow: -o-ellipsis-lastline;
overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;
-webkit-box-orient: vertical;text-align: left;" :title='record.revisit_remark'>
							{{record.revisit_remark}}
						</div>
					</a-table>
					<div class="paginationView">
						<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
					</div>
					<!--:pagination="false" -->
				</div>
			
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['itemobj'],
		data() {
			return {
				tzPageNum: '',
				huiarr:[{
							text: '全部',
							value: ''
						},{
							text: '跟進中',
							value: '1'
						},{
							text: '未跟進',
							value: '2'
						},{
							text: '無效用戶',
							value: '3'
						}],
				admintypeArr: [
					{
							text: '全部',
							value: ''
						},{
						text: '跟進中',
						value: 1
					},
					{
						text: '未跟進',
						value: 2
					}, {
						text: '無效用戶',
						value: 3
					}
				],
				columns: [
					// { title: 'D', dataIndex: 'key' },
					{
						title: '區號/電話',
						dataIndex: '',
						align: 'center',
						width: '17%',
						scopedSlots: {
							customRender: 'telphonenumber'
						}
					},
					{
						title: '國家/地區',
						dataIndex: '',
						align: 'center',
						width: '14%',
						scopedSlots: {
							customRender: 'area'
						}
					},
					{
						title: '中/英文姓名',
						dataIndex: '',
						align: 'center',
						width: '14%',
						scopedSlots: {
							customRender: 'name'
						}
					},
					// {
					// 	title: '英文姓名',
					// 	dataIndex: 'en_name',
					// 	align: 'center',
					// 	width: '14%'
					// },
					{
						title: '開戶進度',
						dataIndex: '',
						align: 'center',
						width: '16%',
						scopedSlots: {
							customRender: 'step'
						}
					},
					{
						title: '提交日期',
						dataIndex: 'createdate',
						align: 'center',
						width: '14%'
					},
					{
						title: '回訪內容',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'revisit_remark'
						}
					},
				],
				columnsData: [],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					enddate: '',
					perPage: 6, //每頁條目數
					revisistatus: '',
					"inviterid": "",
				}
			}
		},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * _this.params.perPage;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum *  _this.params.perPage;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},

		},
		mounted() {
			this.getdate()
		},
		methods: {
			getfn(){
				this.fanhand()
				return this.params
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getdate();
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begindate = this.params.begindate ? App.oDate.secsTime3(this.params.begindate
						._d) : '',
					//認購截止日期
					this.params.enddate = this.params.enddate ? App.oDate.secsTime3(this.params.enddate
						._d) : ''
			},
			getdate() {
				this.params.inviterid = this.itemobj.inviterid
				this.params.begindate = this.params.begindate._d ? App.oDate.secsTime3(this.params.begindate._d) : this
					.params.begindate
				this.params.enddate = this.params.enddate._d ? App.oDate.secsTime3(this.params.enddate._d) : this.params
					.enddate

				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getUnsubm,
					data: this.params
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.columnsData = res.data.unSubmittedKhList
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						this.params.revisitnum = res.data.revisitnum
						this.params.unrevisitnum = res.data.unrevisitnum
						this.params.invalidnum = res.data.invalidnum
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			disabledDate(current) {
				if (this.params.enddate) {
					return current && current > this.params.enddate;
				} else {
					return false
				}
			},
			disabledDates(current) {
				if (this.params.begindate) {
					return current && current < this.params.begindate;
				} else {
					return false
				}
			},
			clearEvent() {
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					enddate: '',
					perPage: 6, //每頁條目數
				}
				this.getdate()
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
		}
	}
</script>

<style lang="scss">
	#weitijao {
		.ant-col-6{
			line-height: 1.7rem;
			display: flex;
			    justify-content: start;
			    align-items: center;
		}
		.ant-col-6>div:first-child{
			margin-right: 10px;
		}
		.wimg {
			width: 1rem;
		}

		.fath_yiti {
			display: flex;
			justify-content: space-between;
		}

		.ant-table-thead>tr:first-child>th:first-child {
			font-size: .8rem;
		}

		.ant-table-thead>tr>th {
			font-size: .8rem;
		}

		.ant-col {
			margin: 0.5rem 0 0.4rem !important;
		}

		.ant-pagination-prev,
		.ant-pagination-next,
		.ant-pagination-jump-prev,
		.ant-pagination-jump-next {
			min-width: 28px;
			height: 1.5rem;
			min-height: 28px;
			line-height: 1.5rem;
		}

		.ant-pagination-item {
			min-width: 28px;
			height: 1.5rem;
			min-height: 28px;
			line-height: 1.5rem;
		}

		.bottomMain {
			background-color: #fff;
			display: flex;
			align-items: center;
			padding: 1.6rem 1.04rem;
		}

		.wrplf {
			display: flex;
			justify-content: space-between;
		}

		.topBtn {
			padding: .8rem 1.04rem;
			border-radius: 2.6rem;
			/* margin-left:0.8rem; */
			color: #fff;
			display: inline-flex;
			align-items: center;
		}

		.ant-table-tbody {}
	}

	#ediotable tr td:nth-last-child(1),
	#ediotable tr th:nth-last-child(1) {
		border-right: 1px solid #e8e8e8 !important;
	}
	#ediotable tr td{
		font-size: .7rem;
	}

	#ediotable .ant-table-bordered .ant-table-thead>tr>th,
	#ediotable .ant-table-bordered .ant-table-tbody>tr>td {
		border-right: unset;
	}

	#weitijao .paginationView {
		padding: 0.5rem 0;
		display: flex;
		align-items: center;
		width: 100%;
		color: #666666;
		/* height:calc(100vh - 142px); */
	}

	#weitijao .ant-pagination-item {
		background-color: #fff;
		border-color: #bfbfbf;
		color: #999999;
		margin-right: 1rem;
	}

	#weitijao .ant-pagination-prev {
		margin-right: 1rem;
	}

	#weitijao .ant-pagination-item a {
		color: inherit;
	}

	#weitijao .ant-pagination-item-active {
		background-color: #f3f3f3;
		border-color: #d8d8d8;
		color: #000;
	}

	#weitijao .ant-pagination-prev .ant-pagination-item-link,
	#weitijao .ant-pagination-next .ant-pagination-item-link {
		background-color: #fff;
		color: #666666;
		border: 1px solid #bfbfbf;
	}

	#weitijao .ant-pagination-disabled a,
	#weitijao .ant-pagination-disabled:hover a,
	#weitijao .ant-pagination-disabled:focus a,
	#weitijao .ant-pagination-disabled .ant-pagination-item-link,
	#weitijao .ant-pagination-disabled:hover .ant-pagination-item-link,
	#weitijao .ant-pagination-disabled:focus .ant-pagination-item-link {
		background-color: #d8d8d8 !important;
		color: #fff !important;
	}

	#weitijao .pageTzView {
		display: flex;
		align-items: center;
		margin-left: 0.7rem;
	}

	#weitijao .pageTzView input {
		width: 2.6rem;
		height: 1.5rem;
		border: 1px solid #bfbfbf;
		outline: unset;
		margin-right: 0.25rem;
		border-radius: 4px;
		text-align: center;
	}

	#weitijao .pageTzView span {
		background-color: #d8d8d8;
		border-radius: 4px;
		height: 1.5rem;
		color: #666666;
		padding: 0 0.625rem;
		line-height: 1.5rem;
	}
</style>
